import { createFileRoute } from '@tanstack/react-router'

import { Frame } from '@/components/frame'
import { PageHeader } from '@/components/page-header'
import { DormantClients } from '@/components/reminders/dormant-clients'
import { parseRemindersSearch } from '@/components/reminders/reminders-search-schema'
import { RemindersWorkspace } from '@/components/reminders/reminders-workspace'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'

export const Route = createFileRoute('/_app/relances')({
  validateSearch: parseRemindersSearch,
  component: RelancesPage,
})

function RelancesPage() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <div className="space-y-6">
      <PageHeader title="Relances" documentTitle="Relances" />

      <Tabs
        value={search.onglet ?? 'relances'}
        onValueChange={(value) => {
          void navigate({
            search: (current) => ({
              ...current,
              onglet: value === 'dormants' ? 'dormants' : undefined,
            }),
          })
        }}
      >
        <TabsList>
          <TabsTrigger value="relances">Relances</TabsTrigger>
          <TabsTrigger value="dormants">Clients dormants</TabsTrigger>
        </TabsList>

        <TabsContent value="relances" className="pt-4">
          <Frame>
            <RemindersWorkspace
              search={search}
              onSearchChange={(next) => {
                void navigate({ search: (current) => ({ ...current, ...next }) })
              }}
            />
          </Frame>
        </TabsContent>
        <TabsContent value="dormants" className="pt-4">
          <Frame>
            <DormantClients />
          </Frame>
        </TabsContent>
      </Tabs>
    </div>
  )
}
